{
  "Müşteriler": "Müşteriler",
  "musteriler": {
    "Müşteriler": "Müşteriler",
    "Ad": "Ad",
    "Soyad": "Soyad",
    "Referans": "Referans",
    "Cep": "Cep",
    "Cep 2": "Cep 2",
    "Meslek": "Meslek",
    "Cinsiyet": "Cinsiyet",
    "Kimlik No": "Kimlik No",
    "Doğum Tarihi": "Doğum Tarihi",
    "Email": "Email",
    "Email 2": "Email 2",
    "Adres": "Adres",
    "İl": "İl",
    "İlçe": "İlçe",
    "Not": "Not",
    "Yetki Talep": "Yetki Talep",
    "Telefon": "Telefon",
    "Onay Bekleyenler": "Onay Bekleyenler",
    "Ara": "Ara",
    "Temizle": "Temizle",
    "Kapat": "Kapat",
    "Durum": "Durum",
    "Onsekizalti": "18 Yaş Altı",
    "Sigorta Ettiren": "Sigorta Ettiren",
    "Yenile": "Yenile"
  }
}
